import { WDD } from '../core/wdd.js';

export function opener() {
    const originalButton = WDD.el.querySelector('.bp-hider__button');
    const hiderInput = WDD.el.querySelector('.bp-hider__input');
    const hiderDiv = WDD.el.querySelector('.bp-content');

    if (!originalButton || !hiderInput || !hiderDiv) return;

    let pendingObserver = null;
    const lastChild = hiderDiv.lastElementChild;

    hiderInput.addEventListener('change', () => {
        if (!lastChild) return;

        if (hiderInput.checked) {
            hiderDiv.addEventListener('transitionend', () => {
                pendingObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            hiderDiv.style.maxHeight = hiderDiv.scrollHeight + 'px';
                            pendingObserver = pendingObserver.unobserve(entry.target);
                        }
                    });
                });
                pendingObserver.observe(lastChild);
            }, { once: true });
        }
        else {
            hiderDiv.style.removeProperty('max-height');

            if (pendingObserver) {
                pendingObserver = pendingObserver.unobserve(lastChild);
            }
        }
    });

    if (hiderInput.checked) {
        hiderDiv.style.maxHeight = hiderDiv.scrollHeight + 'px';
    }
}